import React from 'react';

const CICDConsulting: React.FC = () => {
  return (
    <div className="page cicd-consulting">
      <div className="container">
        <div className="hero-section">
          <h1>CI/CD Consulting Services</h1>
          <p className="hero-description">
            Design and implementation of robust CI/CD pipelines that accelerate software 
            delivery while maintaining quality and security.
          </p>
        </div>

        <section className="coming-soon-section">
          <div className="coming-soon-card">
            <div className="coming-soon-icon">
              <i className="fa-solid fa-infinity"></i>
            </div>
            <h2>Coming Soon</h2>
            <p>
              Detailed CI/CD consulting services are currently under development. This page will include 
              comprehensive information about pipeline design, automation strategies, 
              tool selection, and implementation best practices.
            </p>
            <a href="/contact" className="contact-btn">Contact for Early Access</a>
          </div>
        </section>
      </div>
    </div>
  );
};

export default CICDConsulting;